import { render, staticRenderFns } from "./MarcaLogo.vue?vue&type=template&id=18feb40a&scoped=true"
import script from "./MarcaLogo.vue?vue&type=script&lang=js"
export * from "./MarcaLogo.vue?vue&type=script&lang=js"
import style0 from "./MarcaLogo.vue?vue&type=style&index=0&id=18feb40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18feb40a",
  null
  
)

export default component.exports